const safeDivideHelper = (numerator, denominator) => {
	if (numerator === null || denominator === null) {
		return '0';
	}

	return denominator !== 0 ? (numerator / denominator).toFixed(1) : '0';
};

export default safeDivideHelper;
